import React, { useState, useEffect } from "react";
import "../styles/Home.css";

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState("home");
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
            const sections = ["home","about","education","skills","projects","achievements","contact","resume"];
            for (let section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    if (rect.top <= 200 && rect.bottom >= 200) { setActiveSection(section); break; }
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const sections = [
        { id: "home", label: "Home" },
        { id: "about", label: "About" },
        { id: "education", label: "Education" },
        { id: "skills", label: "Skills" },
        { id: "projects", label: "Projects" },
        { id: "achievements", label: "Achievements" },
        { id: "contact", label: "Contact" },
    ];

    const handleNavClick = (id) => {
        setMenuOpen(false);
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            <nav className="navbar" style={{ boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.08)" : "none" }}>
                <span className="logo">Port<span>folio</span></span>

                {/* Desktop nav */}
                <ul className="nav-links">
                    {sections.map((section) => (
                        <li key={section.id} className={activeSection === section.id ? "active" : ""}>
                            <a href={`#${section.id}`} style={{ color: 'inherit', textDecoration: 'none' }}>{section.label}</a>
                        </li>
                    ))}
                    <a href="#resume" style={{ textDecoration: 'none' }}>
                        <li className={`nav-cta ${activeSection === "resume" ? "active" : ""}`}>Download CV ↓</li>
                    </a>
                </ul>

                {/* Hamburger button */}
                <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
                    <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
                    <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
                    <span className={`ham-line ${menuOpen ? 'open' : ''}`} />
                </button>
            </nav>

            {/* Mobile drawer */}
            {menuOpen && (
                <div className="mobile-nav-drawer">
                    {sections.map((section) => (
                        <a key={section.id} href={`#${section.id}`} className="mobile-nav-link" onClick={() => handleNavClick(section.id)}>
                            {section.label}
                        </a>
                    ))}
                    <a href="#resume" className="mobile-nav-link mobile-nav-cta" onClick={() => setMenuOpen(false)}>
                        Download CV ↓
                    </a>
                </div>
            )}
        </>
    );
}

export default Navbar;
